// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"162":"wide-components","447":"narrow-components","737":"resize-observer-polyfill","992":"reports"}[chunkId] || chunkId) + "." + {"162":"481c39ec","231":"370f17f8","312":"9f087b98","444":"301f7ece","447":"9ae206be","473":"02c273e8","737":"98a18736","848":"aa73d5a0","992":"778a42ee"}[chunkId] + ".chunk.js";
};